<template>
  <modals-request
    v-model="payload"
    :request-class="proxyRequest"
    title="Conciliar transferência?"
    :disabled-send="disabledSave"
    :btn-attrs="btbAttrs"
    :config-swal="swalConfig"
    :label="label"
    persistent
    max-width="600"
    @success="requestCallBack($event)"
  >
    <form-group>
      <v-row>
        <v-col cols="12">
          <v-combobox
            v-if="!item.clientId"
            id="input:originName"
            v-model="payload.originName"
            label="Cliente"
            :items="clientIdOptions"
            :rules="[requiredRule]"
            required
            outlined
            @blur="setClientInfo($event)"
          />
          <input-select
            v-else
            id="input:clientId"
            v-model="payload.clientId"
            label="Cliente"
            :items="clientIdOptions"
            disabled
            outlined
            @change="setClientInfo($event)"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <input-mask
            id="input:originDocument"
            v-model="payload.originDocument"
            label="Documento"
            :rules="[requiredRule]"
            :disabled="!!disabledDocument"
            required
            outlined
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <input-text
            id="input:accountNumber"
            v-model="payload.accountNumber"
            :disabled="!!item.bankAccount.accountNumber"
            label="Número da conta"
            outlined
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <input-text
            id="input:accountVerificationDigit"
            v-model="payload.accountVerificationDigit"
            :disabled="!!item.bankAccount.accountVerificationDigit"
            label="Dígito verificador"
            outlined
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-textarea
            id="input:observation"
            v-model="payload.observation"
            label="Observação"
            :rules="[requiredRule, minLength(10)]"
            rows="5"
            outlined
          />
        </v-col>
      </v-row>
    </form-group>
  </modals-request>
</template>

<script>
import RulesMixin from '@/app/arch/mixins/RulesMixin';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import ModalsRequest from '@/app/arch/components/modals/ModalsRequest.vue';
import ConciliationTedMixin from 'Modules/contacard/conciliations/transfer/conciliation/components/ConciliationTedMixin';

export default {
  name: 'ConciliationActionBtn',
  components: { FormGroup, ModalsRequest },
  mixins: [RulesMixin, ConciliationTedMixin],
  props: {
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
    },
    color: {
      type: String,
      default: '#2ABD49',
    },
    item: {
      type: Object,
      default() {
        return {
          clientId: '',
          clientName: '',
          clientDocument: '',
          bankAccount: {
            bankName: '',
            bankCode: '',
            agency: '',
            accountNumber: '',
            accountVerificationDigit: '',
          },
        };
      },
    },
    loading: {
      type: Boolean,
    },
  },
  data: (vm) => ({
    initialDocument: vm.item.clientDocument,
    clientMessageError: 'Falha ao buscar clientes!',
    clientIdOptions: [],
    payload: {
      conciliationId: vm.getId,
      clientId: vm.item.clientId,
      accountNumber: vm.item.bankAccount.accountNumber,
      accountVerificationDigit: vm.item.bankAccount.accountVerificationDigit,
      originName: vm.item.clientName,
      originDocument: vm.item.clientDocument,
      bankTransferId: '',
      observation: '',
    },
  }),
  computed: {
    btbAttrs() {
      return {
        color: this.color,
        outlined: true,
        disabled: this.disabled,
        loading: this.loading,
      };
    },
    disabledSave() {
      return !(
        this.payload
      && this.payload.observation
      && this.payload.observation.length >= 10
      );
    },
    setClientInfo() {
      return (ev) => {
        const client = this.getClientByName(
          ev.target.value,
        );

        if (client) {
          this.payload.clientId = client.value;
          this.payload.originDocument = client.item.cpfCnpj;
        }
      };
    },
    getClientByName() {
      return (name) => this.clientIdOptions.find(
        (client) => (client.text.includes(name)
          || client.text === client),
      );
    },
    getClientById() {
      return (id) => this.clientIdOptions.find(
        (client) => client.value === id,
      );
    },
    getClientsOptions() {
      return this.clientOptions.clients;
    },
    disabledDocument() {
      return this.getClientId
      && this.initialDocument;
    },
  },
  watch: {
    getClientsOptions: {
      immediate: true,
      handler(value) {
        if (value && value.length) {
          this.clientIdOptions = this.getClientsOptions;
        }
      },
    },
    getClientId: {
      immediate: true,
      handler(id) {
        if (id) {
          const client = this.getClientById(
            this.getClientId,
          );
          this.payload.originDocument = client ? client.item.cpfCnpj : '';
        }
      },
    },
  },
  inject: {
    clientOptions: {
      default: {
        clients: [],
      },
    },
  },
};
</script>
